// #region Imports

import * as $ from 'jquery';

// #endregion Imports

// #region Exports

export function initialize(): void {
    bindInputs();
}

// #endregion Exports

// #region Private constants
const buttonSelector = '.search-result__button';
const tagsSelector = '.search-result__tags';
const parentSelector = '.search-results__item';
// #endregion Private constants

// #region Private functions

export function bindInputs($context?: JQuery, isList?: boolean): void {
    (isList ? $context :
            ($context ? $context.find(buttonSelector) : $(buttonSelector)))
        .on('click', handleClick);
}

function handleClick(event): void {
    event.preventDefault();
    const $button = $(this).toggleClass(buttonSelector.replace('.', '') + '--open');
    $button.closest(parentSelector).find(tagsSelector).toggleClass(tagsSelector.replace('.', '') + '--open');
}

// #endregion Private functions